import t from "@/lang/lang";
import {
  BaseDataPage,
  BaseDataPageContent,
  BaseDataPageDescription,
  BaseDataPageHeader,
  BaseDataPageTitle,
} from "@/routes/base-data/_components/layout/base-data-page";
import { TableCard } from "@/shared/components/tables/table-card";
import { CreateLabDialog } from "@/services/backend/samples/components/create-lab-dialog";
import { LabTable } from "@/services/backend/samples/components/lab-table";
import { useNavigate } from "react-router";

export function LabListRoute() {
  const navigate = useNavigate();

  return (
    <BaseDataPage>
      <BaseDataPageHeader>
        <BaseDataPageTitle>{t("Labore")}</BaseDataPageTitle>
        <BaseDataPageDescription>
          {t(
            "Hier können Labore für die Probenanalyse verwaltet werden. Ein Labor kann für mehrere Analysearten konfiguriert werden.",
          )}
        </BaseDataPageDescription>
      </BaseDataPageHeader>
      <BaseDataPageContent>
        <div className="grid gap-2">
          <div className="ml-auto">
            <CreateLabDialog onSuccess={(lab) => navigate(lab.id)} />
          </div>
          <TableCard>
            <LabTable navigateTo={(lab) => navigate(lab.id)} />
          </TableCard>
        </div>
      </BaseDataPageContent>
    </BaseDataPage>
  );
}
